import { createStyles } from '@/styles/theme/utils';

export const footerStyles = createStyles({
   mainBox: {
      pb: '10',
   },
   container: {
      px: '12',
      '@media (max-width: 767px)': {
         px: '6',
      },
   },
   footerBigTextBox: {
      align: 'center',
      justifyContent: 'center',
      pos: 'relative',
   },
   footerBigText: {
      letterSpacing: 'sm_1',
      color: 'brand',
      fontFamily: 'var(--font-anton)',
      fontWeight: 'normal',
      pos: 'relative',
      fontSize: '412px',
      textTransform: 'uppercase',
      '@media (max-width: 1366px)': {
         fontSize: '312px',
      },
      '@media (max-width: 1280px)': {
         fontSize: '100px',
      },
   },
   footerBigTextImageBox: {
      pos: 'absolute',
      bottom: '80px',
      right: '115px',
      '@media (max-width: 1366px)': {
         bottom: '50px',
         right: '100px',
      },
      '@media (max-width: 1280px)': {
         bottom: '10px',
         right: '20px',
         w: '60px',
      },
   },
   footerLinkContainer: {
      display: { lg: 'flex', base: 'block' },
      alignItems: 'center',
      justifyContent: 'space-between',
   },
   footerLinkBox: {
      fontFamily: 'var(--font-montserrat)',
      textTransform: 'uppercase',
      color: 'brand',
      display: { lg: 'flex', base: 'block' },
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '6',
      fontWeight: 'bold',
      fontSize: 'sm',
   },
   footerLinkText: {
      '@media (max-width: 1024px)': {
         pb: '2',
      },
      _hover: { color: 'white' },
   },
   socialIconBox: {
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4',
      '@media (max-width: 1024px)': {
         pt: '2',
      },
   },
   socialIconButton: {
      borderWidth: '2px',
      borderColor: 'brand',
      _hover: { borderColor: 'white', bg: 'white' },
      borderRadius: 'sm',
      w: '10',
      h: '10',
   },
});
